import { getTrimTypeForConnectionAngle } from '../../panel-trims/helpers';
import { Kitchen } from '../kitchen.class';
import type { KitchenTrimProfile } from '../types';
import { PanelTrimType } from '../../panel-trims/enums';

/**
 * Converts every corner trim in the kitchen to the requested profile
 * @param kitchen the kitchen to convert
 * @param trimProfile 'standard' restores each trim's angle-derived profile; 'flat' makes every trim a flat strip
 */
export const setTrimProfileCfn = (kitchen: Kitchen, trimProfile: KitchenTrimProfile): void => {
	if (trimProfile !== 'standard' && trimProfile !== 'flat') return;

	const wantsFlat = trimProfile === 'flat';

	kitchen.design.islands.children.forEach((island) => {
		(island.panelTrims?.children ?? []).forEach((panelTrim) => {
			if (panelTrim.isFlat === wantsFlat) return;

			const [firstId = null] = panelTrim.panels ?? [];
			const panel = island.panels?.findById(firstId) ?? null;

			panelTrim.setTrimTypePaired(wantsFlat
				? PanelTrimType.straight
				: getTrimTypeForConnectionAngle(panel?.connections?.left?.angle ?? null));
		});
	});
};
